// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/monitoring/v2/monitoring_record.proto (package ai.h2o.mlops.monitoring.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { BaselineAggregation } from "./aggregate_pb.js";
import { Credentials } from "./credential_pb.js";
import { LogicalType } from "./logical_type_pb.js";

/**
 * MonitoringRecord is the entity which represents a monitored model deployment.
 *
 * @generated from message ai.h2o.mlops.monitoring.v2.MonitoringRecord
 */
export const MonitoringRecord = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.mlops.monitoring.v2.MonitoringRecord",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "columns", kind: "message", T: Column, repeated: true },
    { no: 5, name: "baseline_aggregations", kind: "message", T: BaselineAggregation, repeated: true },
    { no: 6, name: "baseline_source", kind: "message", T: BaselineSource },
    { no: 7, name: "timestamp_column", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "experiment_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 9, name: "create_time", kind: "message", T: Timestamp },
    { no: 10, name: "update_time", kind: "message", T: Timestamp },
    { no: 11, name: "creator", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "creator_display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "delete_time", kind: "message", T: Timestamp },
  ],
);

/**
 * BaselineSource represent location of baseline data.
 *
 * @generated from message ai.h2o.mlops.monitoring.v2.BaselineSource
 */
export const BaselineSource = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.mlops.monitoring.v2.BaselineSource",
  () => [
    { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cred", kind: "message", T: Credentials },
  ],
);

/**
 * Column represents a feature column.
 *
 * @generated from message ai.h2o.mlops.monitoring.v2.Column
 */
export const Column = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.mlops.monitoring.v2.Column",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "logical_type", kind: "enum", T: proto3.getEnumType(LogicalType) },
    { no: 4, name: "is_model_output", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

